import {
  ALERT_ERROR,
  HIDE_BLOCKING_LOADER,
  SET_ASSET_DELTA,
  SHOW_BLOCKING_LOADER,
  doFilePreviewPdf,
  doFileShare,
  doSetImagePreview,
} from 'store/actions';
import { put, select, takeEvery } from 'typed-redux-saga';
import { FilesContextEnum } from 'types/types';

import { FileTypeGroupsEnum } from 'service/file/types';
import { getFileTypeFromUntrustedExtension } from 'service/file';
import { isError } from 'lodash';
import { apiFilesDownload, apiFilesPreview } from 'service/api/constants';
import { getImagePreviewUri } from 'store/sagaHelpers';
import { selectFilesContext } from './selectors';
import * as actions from './actions';

export const filesSideEffects = [
  takeEvery(actions.doFileDownload, function* f(action) {
    const { fileId, typeId, context } = action.payload;
    const type = getFileTypeFromUntrustedExtension(typeId);

    if (!type) {
      return;
    }

    if (context === undefined) {
      yield* put(
        ALERT_ERROR({ error: new Error('File download context not set') }),
      );
      return;
    }

    yield* put(doFileShare({ url: apiFilesDownload(fileId, context!) }));
  }),
  takeEvery(actions.doFilePreview, function* f(action) {
    const { fileId, typeId, context } = action.payload;
    const type = getFileTypeFromUntrustedExtension(typeId);

    if (!type) {
      return;
    }

    if (context === undefined) {
      yield* put(
        ALERT_ERROR({ error: new Error('File preview context not set') }),
      );
      return;
    }

    // Image
    if (
      type.group === FileTypeGroupsEnum.image ||
      type.group === FileTypeGroupsEnum.svg
    ) {
      try {
        yield* put(SHOW_BLOCKING_LOADER());
        const data = yield* getImagePreviewUri(fileId, context);
        yield* put(HIDE_BLOCKING_LOADER());
        yield* put(
          doSetImagePreview({
            image: data.image,
          }),
        );
      } catch (error) {
        yield* put(HIDE_BLOCKING_LOADER());
        if (isError(error)) {
          yield* put(ALERT_ERROR({ error }));
        }
      }
      return;
    }

    // PDF
    if (type.group === FileTypeGroupsEnum.pdf) {
      yield* put(doFilePreviewPdf({ url: apiFilesPreview(fileId, context!) }));
      return;
    }

    yield* put(
      ALERT_ERROR({ error: new Error('This file cannot be previewed') }),
    );
  }),
  takeEvery(actions.doFilesDeleteFile, function* f(action) {
    const { fileId } = action.payload;
    const context = yield* select(selectFilesContext);

    if (!context) {
      return;
    }

    if (
      context.context === FilesContextEnum.localAsset ||
      context.context === FilesContextEnum.localAssessment
    ) {
      yield* put(
        SET_ASSET_DELTA({
          id: context.assetId,
          delta: {
            files: {
              [fileId]: null,
            },
          },
        }),
      );
    }
  }),
];
